import React, { useRef, useState, useEffect } from 'react';
import { object, func } from 'prop-types';

const Visit = ({ containerElement, onVisited, onRevisited }) => {
  const [isVisited, setVisited] = useState(false);
  const visitRef = useRef();
  const containerElementDefined = () =>
    !(containerElement === null || containerElement === undefined);

  useEffect(() => {
    if (containerElementDefined()) {
      containerElement.addEventListener('scroll', handleScroll);
    } else {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (containerElementDefined()) {
        containerElement.removeEventListener('scroll', handleScroll);
      } else {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  });

  const handleScroll = () => {
    if (visitRef !== undefined && isElementInViewport()) {
      if (!isVisited) {
        if (typeof onVisited === 'function') {
          onVisited();
          setVisited(true);
        }
      } else if (typeof onRevisited === 'function') {
        onRevisited();
      }
    }
  };

  const isElementInViewport = () => {
    const rect = visitRef.current.getBoundingClientRect();
    let containerBottom = window.innerHeight;
    let containerRight = window.innerWidth;

    if (containerElementDefined()) {
      const containerRect = containerElement.getBoundingClientRect();
      containerBottom = containerRect.bottom;
      containerRight = containerRect.right;
    }
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= containerBottom &&
      rect.right <= containerRight
    );
  };

  return <span ref={visitRef} />;
};

Visit.defaultProps = {
  onVisited: Function.prototype,
  onRevisited: Function.prototype,
};

Visit.propTypes = {
  containerElement: object,
  onVisited: func,
  onRevisited: func,
};

export default Visit;
